import React, { useEffect, useState } from "react";
import upArrow from "../Assets/Images/Dashboard/up_arrow.png";
import downArrow from "../Assets/Images/Dashboard/down_arrow.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  GET_DIET_SCHOOLS_TRAINERS_LIST,
  TEACHER_LIST_GET_API,
} from "../Component/AllApi";
import Loader from "./Loader";
import profile_pic from "../Assets/Images/Dashboard/default_profile.svg";
const BestPerformingTeachers = ({
  school_id,
  schoolDetails,
  principalName,
  referrer,
}) => {
  const location = useLocation();
  const token = localStorage.getItem("authToken");
  const [userRole, setUserRole] = useState(localStorage.getItem("user_role"));
  const [teachers, setTeachers] = useState([]);
  const [sortBy, setSortBy] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");
  //props
  const schoolId = school_id || location.state?.school_id;
  // const SchoolDetails = schoolDetails || location.state.schoolDetails;
  const PrincipalName = principalName || location.state?.principalName;

  // console.log("Props: ",referrer)
  const navigate = useNavigate();
  // eslint-disable
  const [isLoading, setLoading] = useState(false);
  // console.log('Schooldetails props: ',schoolDetails?.trainers)
  // useEffect(() => {
  //   setLoading(true);

  // const DIET_SCHOOLS_LIST_API = GET_DIET_SCHOOLS_TRAINERS_LIST(school_id);
  // const fetchData = async () => {
  //   try {
  //     let response = await fetch(DIET_SCHOOLS_LIST_API, {
  //       method: "GET",
  //       headers: {
  //         Authorization: `bearer ${token}`,
  //       },
  //     });
  //     if (response.ok) {
  //       // role based fetch
  //       let data;
  //       const { schoolTrainers } = await response.json();
  //       data = schoolTrainers;
  //       // if (userRole === "Admin") {
  //       //   const { allTrainers } = await response.json();
  //       //   // console.log("Admin trainer data:", allTrainers);
  //       //   data = allTrainers;
  //       // } else if (userRole === "Principal") {
  //       //   const { schoolTrainers } = await response.json();
  //       //   // console.log("Principal trainer data:", schoolTrainers);
  //       //   data = schoolTrainers;
  //       // } else if (userRole === "Diet") {
  //       //   const { dietTrainers } = await response.json(); // Replace with actual data key
  //       //   console.log("DIET trainer data:", dietTrainers);
  //       //   data = dietTrainers;
  //       // } else {
  //       //   console.error("Unknown role:", userRole);
  //       //   return;
  //       // }

  //       //setting the data
  //       setTeachers(data);
  //     }
  //   } catch (err) {
  //     console.error("Error occured ", err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // fetchData();
  //   setTeachers(schoolDetails?.trainers);
  //   setLoading(false);
  // }, [school_id]);
  useEffect(() => {
    if (schoolDetails && schoolDetails.trainers) {
      setTeachers(schoolDetails.trainers);
      // console.log("Trainers: ",schoolDetails.trainers)
    } else {
      console.warn("No teachers data found in schoolDetails.");
    }
  }, [schoolDetails]);

  // console.log("best is loading", isLoading);

  //   if (isLoading === "true") {
  //     localStorage.setItem("isLoading", true);
  //   } else {
  //     localStorage.setItem("isLoading", false);
  //   }
  const handleSort = (column) => {
    if (sortBy === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortBy(column);
      setSortDirection("asc");
    }
  };

  const sortedData = sortBy
    ? teachers.slice(0, 5).sort((a, b) => {
        const keyA = a[sortBy];
        const keyB = b[sortBy];
        if (sortDirection === "asc") {
          return keyA.localeCompare(keyB);
        } else {
          return keyB.localeCompare(keyA);
        }
      })
    : teachers.slice(0, 5);

  const handleViewAll = () => {
    navigate("/teachers");
  };
  return (
    <>
      <section className="bestSchools mb-5">
        <div className="row mt-5">
          <div className="col-lg-8">
            <p className="main_title"> Teacher List</p>
          </div>

          {/* <div className="col-lg-4">
            <Link
              to="/schoolBestTrainers"
              state={{
                school_id: school_id,
                schoolDetails: schoolDetails,
                principalName: principalName,
                referrer:referrer,
              }}
            >
              <button className="viewAllBtn btn">View All</button>
            </Link>
          </div> */}
        </div>
        <div
          className="backgroundDiv"
          style={{ position: "relative", minHeight: "200px" }}
        >
          {isLoading ? (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 9999,
              }}
            >
              <Loader />
            </div>
          ) : sortedData?.length < 0 || sortedData?.length === 0 ? (
            <>
              <p className="progressMainTitle text-center">No data available</p>
            </>
          ) : (
            <div className="card " style={{ border: "none" }}>
              <div
                className=" table-responsive  card-body"
                style={{ maxHeight: "750px" }}
              >
                <table className="table table-borderless table-responsive">
                  <thead style={{ marginBottom: "20px" }} className="thead_div">
                    <tr>
                      <th
                        style={{ width: "6%" }}
                        className="thead_div_row pb-4"
                      >
                        Sr. No
                      </th>
                      <th scope="col" className="thead_div_row pb-4">
                        Teacher &nbsp;
                      </th>

                      <th scope="col" className="thead_div_row pb-4">
                        Teacher Mobile
                      </th>
                      <th scope="col" className="thead_div_row pb-4">
                        Email ID{" "}
                      </th>
                      {/* <th scope="col" className="thead_div_row pb-4">
                        Location{" "}
                      </th> */}

                      {/* <th
                        scope="col"
                        className="thead_div_row pb-4 ps-4"
                        style={{ width: "20%" }}
                      >
                        Authorization (Active User)
                      </th> */}

                      {/* <th
                        scope="col"
                        className="thead_div_row pb-4 ps-4"
                        style={{ width: "15%" }}
                      >
                        Ass. attempts
                      </th>

                      <th
                        scope="col"
                        className="thead_div_row pb-4 ps-4"
                        style={{ width: "15%" }}
                      >
                        Ass. Score
                      </th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {sortedData.map((userData, index) => (
                      <tr key={index}>
                        <td
                          className="header_srNo"
                          style={{ paddingBottom: "36px" }}
                        >
                          {index + 1}
                        </td>
                        <td className="d-flex">
                          {/* {userData.tra_name} */}
                          <Link
                            to="/teacherParticularData"
                            style={{ textDecoration: "none" }}
                            onClick={() => {
                              localStorage.setItem(
                                "trainer_id",
                                userData.tra_id
                              );
                              localStorage.setItem(
                                "trainer_name",
                                userData.tra_name
                              );
                            }}
                            state={{
                              trainerId: userData.tra_id,
                              referrer: referrer,
                              school_id: schoolId,
                              // schoolDetails:SchoolDetails,
                              principalName:PrincipalName
                            }}
                          >
                            <img
                              src={
                                userData.tra_image === null ||
                                userData.tra_image === ""
                                  ? profile_pic
                                  : userData.tra_image
                              }
                              style={{
                                width: "24px",
                                height: "24px",
                              }}
                              onError={(e) => {
                                e.target.src = profile_pic;
                              }}
                              alt="profilePic"
                            />

                            <span className="allocatedTeacher ms-2">
                              {userData.tra_name ? userData.tra_name : "-"}
                            </span>
                          </Link>
                        </td>

                        <td className="teacher_mobile">
                          {userData.tra_phone ? userData.tra_phone : "-"}
                        </td>
                        <td className="location_text">
                          {userData.tra_email ? userData.tra_email : "-"}
                        </td>
                        {/* <td className="location_text">
                          {userData.tra_address}
                        </td> */}

                        {/* <td style={{ textAlign: "center" }}>
                          {userData.tra_assessment_attempt
                            ? userData.tra_assessment_attempt
                            : "-"}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {userData.tra_assessment_score
                            ? userData.tra_assessment_score
                            : "-"}
                        </td> */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default BestPerformingTeachers;
